<template>
  <v-card class="pa-5" elevation="1">
    <v-card-title class="px-0 pt-0">Revendedores</v-card-title>

    <DataTable
      no-sync
      :headers="headers"
      :items="resellers"
      :loading="loading"
    />
  </v-card>
</template>

<script>
import { DataTable } from '@/components/vuetify';

export default {
  name: 'AdminResellers',
  components: { DataTable },
  data() {
    return {
      loading: false,
      resellers: [],
      headers: [
        { text: 'Nome', value: 'name' },
        { text: 'E-mail', value: 'email' },
        { text: 'Telefone', value: 'phone' },
        { text: 'Distribuidor', value: 'distributor_name' },
        { text: 'Clientes', value: 'customers_count' },
      ],
    };
  },
  mounted() {
    this.fetchResellers();
  },
  methods: {
    fetchResellers() {
      this.loading = true;
      this.$api.admin
        .getResellers()
        .then(({ data }) => {
          this.resellers = (data.resellers || []).map((reseller) => ({
            ...reseller,
            distributor_name: reseller.distributor ? reseller.distributor.name : '-',
            customers_count: reseller.customers ? reseller.customers.length : 0,
          }));
        })
        .catch(() => {
          this.$noty.error('Erro ao carregar os revendedores');
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
